import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";

$.extend(uly, {
    utils: $.extend(uly.utils, {
        get_random: function(){
            return Math.floor(Math.random() * 100000000);
        },
        _current_guids:[],
        new_guid: () => {
            if (uly.utils._current_guids.length > 0) {
                var res = Promise.Deferred();
                res.resolve(uly.utils._current_guids.pop());
                return res;
            } else {
                return uly.api.start().follow("uly:newguid", {n: 10}).then((res)=> {
                    console.log("got res:", res.new_guid);
                    uly.utils._current_guids = res.guids;
                    return res.new_guid;
                })
            }
        },
        str_replace_async: function replaceAsync(str, regex, asyncFn) {
            const promises = [];
            str.replace(regex, (match, ...args) => {
                const promise = asyncFn(match, ...args);
                promises.push(promise);
            });
            return Promise.all(promises).then( (data) => {
                return str.replace(regex, () => data.shift());
            });
        },
        is_type: function(obj, typename) {
            var o_type = Object.prototype.toString.call(obj).slice(8, -1);
            if(!typename || !(typename.typeof() === "String"))
                return o_type;
            return o_type === typename;
        },
        parse_filters: function(filters){
            var result = [], data={};
            $.each(filters, function(mode,value) {
                if (mode == "filter_model") {
                    for (var i=0;i<value.length;i++){
                        var tmp = value[i];
                        var key = tmp[0];
                        var val = [tmp[1], tmp[2], tmp[3]];
                        var op = ko.utils.unwrapObservable(val[0]);
                        var binder = val[2];
                        val = val[1];
                        if (typeof val != "function") {
                            if (typeof val == typeof "") {
                                if (val[0] == val.slice(-1) && (val[0] == "'"  || val[0] == "\""))
                                    val = val.slice(1,-1);
                            }
                        }
                        else val = val();
                        if (key == "id" && val.indexOf("#") >= 0){
                            val = val.slice(val.indexOf("#")+1);
                        }
                        if (binder) result.push([key,op,"\""+val+"\"", " ", binder].join(""));
                        else result.push([key,op,"\""+val+"\""].join(""));
                    }
                } else {
                    var expression = ko.unwrap(value);
                    if (expression) result.push(value);
                }
            });
            if (result.length > 0){
                data["filters"] = result.join("\n");
            }
            return data;
        },
        is_mobile : function(){
            //we assume mobile if touch screen.
            var msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture;
            var touchSupport = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch &&     document instanceof DocumentTouch);
            return touchSupport;
            //return Modernizr.touch;
            //return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
        },
        is_link_external: function(href) {
            var uri = new URI(href.toLowerCase());
            var current_uri = new URI(document.location.href.toLowerCase());
            if (!uri.hostname() || (uri.hostname() == current_uri.hostname() && uri.scheme() == current_uri.scheme()))
                return false;
            if (navigator.app && navigator.app.loadUrl) {
                //cordova. need to make sure uri isn't starting with the uly.root
                current_uri = new URI(uly.root.toLowerCase());
                if (!uri.hostname() || (uri.hostname() == current_uri.hostname() && uri.scheme() == current_uri.scheme()))
                    return false;
            }
            return true;
        },
        decode_html_entities : function(str){
            if(str && typeof str === "string") {
                // strip script tags
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, "");
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, "");
                var element = $("<div></div");
                element.innerHTML = str;
                str = element.textContent;
                element.textContent = "";
            }
            return str;
        },
        get_bound_entity: function(elt_or_context) {
            if (!elt_or_context) {
                return ko.unwrap(uly.page.page_resource);
            }

            if (!elt_or_context.$data) {
                elt_or_context = ko.contextFor($(elt_or_context)[0]);
            }
            if (!elt_or_context)
                return null;

            //first check $data
            var candidates = [elt_or_context.$data];
            candidates = candidates.concat(elt_or_context.$parents);
            var result = null;
            $.each(candidates, function(idx, context) {
                if (context && ko.unwrap(context._links) && ko.unwrap(context._links).self && ko.unwrap(context.unique_id))
                {
                    result = context;
                    return false;
                }
                if (context && ko.unwrap(context.widget_data) && ko.unwrap(ko.unwrap(context.widget_data)._links) && ko.unwrap(ko.unwrap(context.widget_data)._links).self && ko.unwrap(context.widget_data).unique_id)
                {
                    result = ko.unwrap(context.widget_data);
                    return false;
                }
                if (context && ko.unwrap(context.page_resource))
                {
                    result = ko.unwrap(context.page_resource);
                    return false;
                }
                if (context && ko.unwrap(context.__link) && ko.unwrap(context.unique_id) && ko.unwrap(context.id)) {
                    result = context;
                    return false;
                }
            });
            return result;
        },
        get_bound_resource: function(elt_or_context) {
            if (!elt_or_context) {
                return  ko.unwrap(uly.page.page_resource);
            }

            if (!elt_or_context.$data) {
                elt_or_context = ko.contextFor($(elt_or_context)[0]);
            }

            if (!elt_or_context)
                return null;
            //first check $data
            var candidates = [elt_or_context.$data];
            candidates = candidates.concat(elt_or_context.$parents);
            var result = null;
            var qualified = $.map(candidates, function(context) {
                if (ko.unwrap(context._links) && ko.unwrap(context._links).self)
                {
                    return context;
                }
                if (ko.unwrap(context.widget_data) && ko.unwrap(ko.unwrap(context.widget_data)._links) && ko.unwrap(ko.unwrap(context.widget_data)._links).self)
                {
                    return ko.unwrap(context.widget_data);
                }
                if (ko.unwrap(context.page_resource))
                {
                    return ko.unwrap(context.page_resource);
                }
            });
            if (qualified.length == 0)
                return null;
            if (qualified.length == 1)
                return qualified[0];
            $.each(qualified, function(idx, val) {
                if (val.type) {
                    result = val;
                    return false;
                }
            });
            if (result)
                return result;
            return qualified[0];
        },
        get_bound_entity_id: function get_bound_entity_id(elt_or_context) {
            var entity = this.get_bound_entity(elt_or_context);
            if (entity && entity.unique_id)
                return ko.unwrap(entity.unique_id);
            entity = this.get_bound_resource(elt_or_context);
            if (entity && entity.unique_id)
                return ko.unwrap(entity.unique_id);
            return null;
        },
        ask_for_redirect:function(data){
            var results = uly.utils.get_results(data);
            if(results && results.success)
                uly.utils.notify(
                    $.trim(_("ask_for_redirect", "Click here to navigate to page") + " " + (results.info || results.message)),
                    _("click_for_redirect","Click here to redirect"),
                    "redirect",
                    function(elt, data){
                        $(elt).css({"cursor":"pointer"}).bind(
                            "click",
                            function(e){
                                e.preventDefault();
                                uly.actions.redirect(data);
                                $(elt).fadeOut(400, function(){this.remove();});
                                return false;
                            }
                        );
                    },
                    data
                );
        },
        notify:function(title, body, type, after_open, data){
            var durations = {error : 5000, redirect : 7000};
            var styles = {error:"alert alert-danger", redirect:"alert alert-warning"};
            $.gritter.add({class_name:type in styles ? styles[type] : "alert alert-info", title:title, text:body, sticky:false, time: type && (type in durations) ? durations[type] : 2000, after_open:function(elt){
                after_open && after_open.call(this, elt, data);
                return false;
            }});
            return false;
        },
        get_results:function(error_or_xhr){
            var results = null;
            if (Object.typeof(error_or_xhr) == "String"){
                results = {"success":false, "error":error_or_xhr };
            } else if (Object.isObject(error_or_xhr)) {
                if ((error_or_xhr.error && typeof error_or_xhr.error != "function") || (typeof error_or_xhr.success != "undefined" && typeof error_or_xhr.success != "function")) {
                    results = error_or_xhr;
                }else if (error_or_xhr.responseJSON) {
                    return uly.utils.get_results(error_or_xhr.responseJSON);
                }
            }
            return results;
        },
        show_results: function(error_or_xhr) {
            var results = uly.utils.get_results(error_or_xhr);
            if (!results)
                return;
            var msgType = "info";
            var msgBody = results.info || results.message;
            if (!results.success)  {
                msgType = "error";
                msgBody = results.error;
            }
            if (msgBody) {
                var msgTitle = results.success ? _("main_information", "Information") : _("main_error", "Error");
                uly.utils.notify(msgTitle, msgBody, msgType.toLowerCase());
            }
        },
        maybe_redirect: function(result) {
            if (!result)
                return false;
            let loc  = result.redirect_to || result.location || result.popup_location;
            if (!loc)
                return false;
            if (result.redirect_to || result.location) {
                if (loc.indexOf("action:") == 0) {
                    loc = loc.slice(7);
                    if (loc.indexOf(":") == 0) {
                        loc = loc.slice(1);
                        //force away navigation before execution
                        uly.actions.navigateto("/");
                    }
                    return uly.actions[loc]();
                } else {
                    uly.actions.navigateto(loc);
                }
            } else {
                window.open(uly.api.getAuthenticatedUrl(loc + "/download"));
            }
        },
        throttle: function(lock, func, delay) {
            var def = Promise.Deferred();
            if (lock.timeout) {
                clearTimeout(lock.timeout);
                lock.timeout = null;
            }
            lock.timeout = setTimeout(function() {
                try {
                    def.resolve(func());
                }
                catch (e) {
                    def.reject(e);
                }
                lock.timeout = null;
            }, delay || 500);
            return def;
        },
        get_relative_resource_uri: function(url) {
            var uri = URI(url);
            return uri.relativeTo(uly.api.root +"/").toString();
        },
        get_root: function() {
            var root = uly.root;
            if (root)
                return root;
            //ok try to get it from meta tag
            root = $("meta[name=ulysses-root]").attr("content");
            if (root)
                return root;
            var base = $("base").attr("href");
            if (base) {
                var u1 = new URI(base);
                var u2 = new URI(document.location.href);
                u1.host(u2.host());
                u1.scheme(u2.scheme());
                return u1.href();
            }
            
            //ok not in meta, we're in cordova...
            var baseUri = document.baseURI;
            root = document.location.href;
            if (baseUri && baseUri != root) {
                return baseUri;
            }
            var tokens = root.split("/");
            if (tokens.length > 1) {
                root = root.substring(0, root.length - tokens[tokens.length-1].length);
            }
            return root || ".";

        },
        find_in_context: function(elt_or_context, predicate) {
            if (!elt_or_context) {
                return  ko.unwrap(uly.page.page_resource);
            }

            if (!elt_or_context.$data) {
                elt_or_context = ko.contextFor($(elt_or_context)[0]);
            }

            if (!elt_or_context)
                return null;

            //first check $data
            var candidates = [elt_or_context.$data];
            candidates = candidates.concat(elt_or_context.$parents);
            var qualified = $.map(candidates, function(context) {
                return predicate(context);
            });
            if (qualified.length == 0)
                return null;
            return qualified[0];
        },
        generate_epic_id: function() {
            return "xxxxxxxxxxxxxxyxxx3xxxxxxxxxxxxx".replace(
                /[xy]/g,
                function(c) {
                    var r = Math.random()*16|0;
                    var v = c == "x" ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
        },
        trigger_action(action, elt, paramaters) {
            if (action && elt) {
                if (typeof uly.actions[action] !== "undefined") {
                    uly.actions[action]({}, $(elt), paramaters);                               
                } else {
                    $(elt).trigger("action:" + action, paramaters);
                }
            }
        }
    })

});